import { runDemo } from "../shared/demoRunner";
import { createV8Scene } from "./scene";

runDemo({ createScene: createV8Scene });
